import 'angular';
import 'angular-resource';
import 'angular-animate';
import 'angular-loading-bar';
import 'bootstrap-loader';
import 'angular-ui-bootstrap';
import 'jquery';
var ol = window.ol = require('openlayers');
import '../../node_modules/openlayers/dist/ol.css';

export default angular.module('wgg', [
    'ngAnimate',
    'angular-loading-bar',
    'ui.bootstrap'
]);




// WEBPACK FOOTER //
// ./src/wgg/wgg.module.js